import React, {Component} from 'react';
import logo from '../../../images/logo_dashbo_purple.svg';
import logotipo from '../../../images/logotipo_dashbo_purple.svg';
import {APIClient} from "../../../utils/APIClient";
import {LocalStorage} from "../../../utils/LocalStorage";
import {Navigate} from "react-router-dom";
import {API_URL} from "../../../settings/local_settings";
import {Spinner} from "../../Spinner";
import { withTranslation } from 'react-i18next';

class LoginCrm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formData: {
                email: '',
                password: '',
            },
            saving: false,
            invalidCredentials: false,
            isLoggedIn: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true});

        new APIClient(API_URL + 'crm/login').login({...this.state.formData}).then((response) => {
            this.setState({saving: false});
            if (response === 'UNAUTHORIZED') {
                this.setState({invalidCredentials: true});
            } else {
                const userData = response.data;
                LocalStorage.saveUserData(userData.user_id, userData.token, userData.user_type, userData.agency_status, userData.language, userData.client_id);
                this.setState({isLoggedIn: true})
            }
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const name = target.name;

        this.setState({
            formData: {
                ...this.state.formData,
                [name]: target.value
            }
        });
    }

    render() {
        const { t } = this.props;
        if (this.state.isLoggedIn) {
            return <Navigate to={{pathname: '/crm'}}/>
        }

        return (
            <div className="crm-login-content">
                <div className="crm-login-box">
                    <img src={logo} className="app-logo" alt="logo"/>
                    <img src={logotipo} className="app-logo-name" alt="logotipo"/>
                    <form className="login-form" onSubmit={this.handleSubmit} method="post">
                        <div className="form-row">
                            <input name="email" type="email" placeholder={t('login.email_placeholder')}
                                   value={this.state.email} onChange={this.handleInputChange}/>
                        </div>
                        <div className="form-row">
                            <input name="password" type="password" placeholder={t('login.password_placeholder')}
                                   value={this.state.password} onChange={this.handleInputChange}/>
                        </div>
                        <div className="submit-row">
                            <LoginCrmButton loading={this.state.saving}/>
                        </div>
                        <LoginMessage fail={this.state.invalidCredentials}/>
                    </form>
                </div>
            </div>
        );
    }
}

class LoginCrmButton extends Component {

    render() {
        const { t } = this.props;
        if (this.props.loading) {
            return (
                <button className="crm-login">
                    <Spinner color="negative small"/>
                </button>
            );
        }

        return (
            <input type="submit" value={t('login.login_button')} className="crm-login"/>
        );
    }
}

class LoginMessage extends Component {

    render() {
        const { t } = this.props;
        if (this.props.fail) {
            return (
                <p className="login-message -fail">{t('login.invalid_credentials')}</p>
            );
        }

        return (
            <p className="login-message">{t('login.type_credentials_message')}</p>
        );
    }
}

const TranslatedLoginCrm = withTranslation()(LoginCrm);
const TranslatedLoginCrmButton = withTranslation()(LoginCrmButton);
const TranslatedLoginMessage = withTranslation()(LoginMessage);

export { TranslatedLoginCrm as LoginCrm, TranslatedLoginCrmButton as LoginCrmButton, TranslatedLoginMessage as LoginMessage };
